import { useThemeVariable } from '@dsx-react/util';

const themeColorValuesObject = {
  'color-accent-0-static': 1,
  'color-accent-0': 1,
  'color-accent-100-static': 1,
  'color-accent-100': 1,
  'color-accent-1000-static': 1,
  'color-accent-1000': 1,
  'color-accent-200-static': 1,
  'color-accent-200': 1,
  'color-accent-300-static': 1,
  'color-accent-300': 1,
  'color-accent-400-static': 1,
  'color-accent-400': 1,
  'color-accent-50-static': 1,
  'color-accent-50': 1,
  'color-accent-500-static': 1,
  'color-accent-500': 1,
  'color-accent-600-static': 1,
  'color-accent-600': 1,
  'color-accent-700-static': 1,
  'color-accent-700': 1,
  'color-accent-75-static': 1,
  'color-accent-75': 1,
  'color-accent-800-static': 1,
  'color-accent-800': 1,
  'color-accent-900-static': 1,
  'color-accent-900': 1,
  'color-accent-950-static': 1,
  'color-accent-950': 1,
  'color-accent-alt-0-static': 1,
  'color-accent-alt-0': 1,
  'color-accent-alt-100-static': 1,
  'color-accent-alt-100': 1,
  'color-accent-alt-1000-static': 1,
  'color-accent-alt-1000': 1,
  'color-accent-alt-200-static': 1,
  'color-accent-alt-200': 1,
  'color-accent-alt-300-static': 1,
  'color-accent-alt-300': 1,
  'color-accent-alt-400-static': 1,
  'color-accent-alt-400': 1,
  'color-accent-alt-50-static': 1,
  'color-accent-alt-50': 1,
  'color-accent-alt-500-static': 1,
  'color-accent-alt-500': 1,
  'color-accent-alt-600-static': 1,
  'color-accent-alt-600': 1,
  'color-accent-alt-700-static': 1,
  'color-accent-alt-700': 1,
  'color-accent-alt-75-static': 1,
  'color-accent-alt-75': 1,
  'color-accent-alt-800-static': 1,
  'color-accent-alt-800': 1,
  'color-accent-alt-900-static': 1,
  'color-accent-alt-900': 1,
  'color-accent-alt-950-static': 1,
  'color-accent-alt-950': 1,
  'color-accent-alt-static': 1,
  'color-accent-alt': 1,
  'color-accent-static': 1,
  'color-accent': 1,
  'color-blue-0-static': 1,
  'color-blue-0': 1,
  'color-blue-100-static': 1,
  'color-blue-100': 1,
  'color-blue-1000-static': 1,
  'color-blue-1000': 1,
  'color-blue-200-static': 1,
  'color-blue-200': 1,
  'color-blue-300-static': 1,
  'color-blue-300': 1,
  'color-blue-400-static': 1,
  'color-blue-400': 1,
  'color-blue-50-static': 1,
  'color-blue-50': 1,
  'color-blue-500-static': 1,
  'color-blue-500': 1,
  'color-blue-600-static': 1,
  'color-blue-600': 1,
  'color-blue-700-static': 1,
  'color-blue-700': 1,
  'color-blue-75-static': 1,
  'color-blue-75': 1,
  'color-blue-800-static': 1,
  'color-blue-800': 1,
  'color-blue-900-static': 1,
  'color-blue-900': 1,
  'color-blue-950-static': 1,
  'color-blue-950': 1,
  'color-blue-static': 1,
  'color-blue': 1,
  'color-cyan-0-static': 1,
  'color-cyan-0': 1,
  'color-cyan-100-static': 1,
  'color-cyan-100': 1,
  'color-cyan-1000-static': 1,
  'color-cyan-1000': 1,
  'color-cyan-200-static': 1,
  'color-cyan-200': 1,
  'color-cyan-300-static': 1,
  'color-cyan-300': 1,
  'color-cyan-400-static': 1,
  'color-cyan-400': 1,
  'color-cyan-50-static': 1,
  'color-cyan-50': 1,
  'color-cyan-500-static': 1,
  'color-cyan-500': 1,
  'color-cyan-600-static': 1,
  'color-cyan-600': 1,
  'color-cyan-700-static': 1,
  'color-cyan-700': 1,
  'color-cyan-75-static': 1,
  'color-cyan-75': 1,
  'color-cyan-800-static': 1,
  'color-cyan-800': 1,
  'color-cyan-900-static': 1,
  'color-cyan-900': 1,
  'color-cyan-950-static': 1,
  'color-cyan-950': 1,
  'color-cyan-static': 1,
  'color-cyan': 1,
  'color-danger-0-static': 1,
  'color-danger-0': 1,
  'color-danger-100-static': 1,
  'color-danger-100': 1,
  'color-danger-1000-static': 1,
  'color-danger-1000': 1,
  'color-danger-200-static': 1,
  'color-danger-200': 1,
  'color-danger-300-static': 1,
  'color-danger-300': 1,
  'color-danger-400-static': 1,
  'color-danger-400': 1,
  'color-danger-50-static': 1,
  'color-danger-50': 1,
  'color-danger-500-static': 1,
  'color-danger-500': 1,
  'color-danger-600-static': 1,
  'color-danger-600': 1,
  'color-danger-700-static': 1,
  'color-danger-700': 1,
  'color-danger-75-static': 1,
  'color-danger-75': 1,
  'color-danger-800-static': 1,
  'color-danger-800': 1,
  'color-danger-900-static': 1,
  'color-danger-900': 1,
  'color-danger-950-static': 1,
  'color-danger-950': 1,
  'color-danger-static': 1,
  'color-danger': 1,
  'color-default-0-static': 1,
  'color-default-0': 1,
  'color-default-100-static': 1,
  'color-default-100': 1,
  'color-default-1000-static': 1,
  'color-default-1000': 1,
  'color-default-200-static': 1,
  'color-default-200': 1,
  'color-default-300-static': 1,
  'color-default-300': 1,
  'color-default-400-static': 1,
  'color-default-400': 1,
  'color-default-50-static': 1,
  'color-default-50': 1,
  'color-default-500-static': 1,
  'color-default-500': 1,
  'color-default-600-static': 1,
  'color-default-600': 1,
  'color-default-700-static': 1,
  'color-default-700': 1,
  'color-default-75-static': 1,
  'color-default-75': 1,
  'color-default-800-static': 1,
  'color-default-800': 1,
  'color-default-900-static': 1,
  'color-default-900': 1,
  'color-default-950-static': 1,
  'color-default-950': 1,
  'color-default-static': 1,
  'color-default': 1,
  'color-gray-0-static': 1,
  'color-gray-0': 1,
  'color-gray-100-static': 1,
  'color-gray-100': 1,
  'color-gray-1000-static': 1,
  'color-gray-1000': 1,
  'color-gray-200-static': 1,
  'color-gray-200': 1,
  'color-gray-300-static': 1,
  'color-gray-300': 1,
  'color-gray-400-static': 1,
  'color-gray-400': 1,
  'color-gray-50-static': 1,
  'color-gray-50': 1,
  'color-gray-500-static': 1,
  'color-gray-500': 1,
  'color-gray-600-static': 1,
  'color-gray-600': 1,
  'color-gray-700-static': 1,
  'color-gray-700': 1,
  'color-gray-75-static': 1,
  'color-gray-75': 1,
  'color-gray-800-static': 1,
  'color-gray-800': 1,
  'color-gray-900-static': 1,
  'color-gray-900': 1,
  'color-gray-950-static': 1,
  'color-gray-950': 1,
  'color-gray-static': 1,
  'color-gray': 1,
  'color-green-0-static': 1,
  'color-green-0': 1,
  'color-green-100-static': 1,
  'color-green-100': 1,
  'color-green-1000-static': 1,
  'color-green-1000': 1,
  'color-green-200-static': 1,
  'color-green-200': 1,
  'color-green-300-static': 1,
  'color-green-300': 1,
  'color-green-400-static': 1,
  'color-green-400': 1,
  'color-green-50-static': 1,
  'color-green-50': 1,
  'color-green-500-static': 1,
  'color-green-500': 1,
  'color-green-600-static': 1,
  'color-green-600': 1,
  'color-green-700-static': 1,
  'color-green-700': 1,
  'color-green-75-static': 1,
  'color-green-75': 1,
  'color-green-800-static': 1,
  'color-green-800': 1,
  'color-green-900-static': 1,
  'color-green-900': 1,
  'color-green-950-static': 1,
  'color-green-950': 1,
  'color-green-static': 1,
  'color-green': 1,
  'color-highlight-0-static': 1,
  'color-highlight-0': 1,
  'color-highlight-100-static': 1,
  'color-highlight-100': 1,
  'color-highlight-1000-static': 1,
  'color-highlight-1000': 1,
  'color-highlight-200-static': 1,
  'color-highlight-200': 1,
  'color-highlight-300-static': 1,
  'color-highlight-300': 1,
  'color-highlight-400-static': 1,
  'color-highlight-400': 1,
  'color-highlight-50-static': 1,
  'color-highlight-50': 1,
  'color-highlight-500-static': 1,
  'color-highlight-500': 1,
  'color-highlight-600-static': 1,
  'color-highlight-600': 1,
  'color-highlight-700-static': 1,
  'color-highlight-700': 1,
  'color-highlight-75-static': 1,
  'color-highlight-75': 1,
  'color-highlight-800-static': 1,
  'color-highlight-800': 1,
  'color-highlight-900-static': 1,
  'color-highlight-900': 1,
  'color-highlight-950-static': 1,
  'color-highlight-950': 1,
  'color-highlight-static': 1,
  'color-highlight': 1,
  'color-info-0-static': 1,
  'color-info-0': 1,
  'color-info-100-static': 1,
  'color-info-100': 1,
  'color-info-1000-static': 1,
  'color-info-1000': 1,
  'color-info-200-static': 1,
  'color-info-200': 1,
  'color-info-300-static': 1,
  'color-info-300': 1,
  'color-info-400-static': 1,
  'color-info-400': 1,
  'color-info-50-static': 1,
  'color-info-50': 1,
  'color-info-500-static': 1,
  'color-info-500': 1,
  'color-info-600-static': 1,
  'color-info-600': 1,
  'color-info-700-static': 1,
  'color-info-700': 1,
  'color-info-75-static': 1,
  'color-info-75': 1,
  'color-info-800-static': 1,
  'color-info-800': 1,
  'color-info-900-static': 1,
  'color-info-900': 1,
  'color-info-950-static': 1,
  'color-info-950': 1,
  'color-info-static': 1,
  'color-info': 1,
  'color-lime-0-static': 1,
  'color-lime-0': 1,
  'color-lime-100-static': 1,
  'color-lime-100': 1,
  'color-lime-1000-static': 1,
  'color-lime-1000': 1,
  'color-lime-200-static': 1,
  'color-lime-200': 1,
  'color-lime-300-static': 1,
  'color-lime-300': 1,
  'color-lime-400-static': 1,
  'color-lime-400': 1,
  'color-lime-50-static': 1,
  'color-lime-50': 1,
  'color-lime-500-static': 1,
  'color-lime-500': 1,
  'color-lime-600-static': 1,
  'color-lime-600': 1,
  'color-lime-700-static': 1,
  'color-lime-700': 1,
  'color-lime-75-static': 1,
  'color-lime-75': 1,
  'color-lime-800-static': 1,
  'color-lime-800': 1,
  'color-lime-900-static': 1,
  'color-lime-900': 1,
  'color-lime-950-static': 1,
  'color-lime-950': 1,
  'color-lime-static': 1,
  'color-lime': 1,
  'color-neutral-0-static': 1,
  'color-neutral-0': 1,
  'color-neutral-100-static': 1,
  'color-neutral-100': 1,
  'color-neutral-1000-static': 1,
  'color-neutral-1000': 1,
  'color-neutral-200-static': 1,
  'color-neutral-200': 1,
  'color-neutral-300-static': 1,
  'color-neutral-300': 1,
  'color-neutral-400-static': 1,
  'color-neutral-400': 1,
  'color-neutral-50-static': 1,
  'color-neutral-50': 1,
  'color-neutral-500-static': 1,
  'color-neutral-500': 1,
  'color-neutral-600-static': 1,
  'color-neutral-600': 1,
  'color-neutral-700-static': 1,
  'color-neutral-700': 1,
  'color-neutral-75-static': 1,
  'color-neutral-75': 1,
  'color-neutral-800-static': 1,
  'color-neutral-800': 1,
  'color-neutral-900-static': 1,
  'color-neutral-900': 1,
  'color-neutral-950-static': 1,
  'color-neutral-950': 1,
  'color-neutral-static': 1,
  'color-neutral': 1,
  'color-orange-0-static': 1,
  'color-orange-0': 1,
  'color-orange-100-static': 1,
  'color-orange-100': 1,
  'color-orange-1000-static': 1,
  'color-orange-1000': 1,
  'color-orange-200-static': 1,
  'color-orange-200': 1,
  'color-orange-300-static': 1,
  'color-orange-300': 1,
  'color-orange-400-static': 1,
  'color-orange-400': 1,
  'color-orange-50-static': 1,
  'color-orange-50': 1,
  'color-orange-500-static': 1,
  'color-orange-500': 1,
  'color-orange-600-static': 1,
  'color-orange-600': 1,
  'color-orange-700-static': 1,
  'color-orange-700': 1,
  'color-orange-75-static': 1,
  'color-orange-75': 1,
  'color-orange-800-static': 1,
  'color-orange-800': 1,
  'color-orange-900-static': 1,
  'color-orange-900': 1,
  'color-orange-950-static': 1,
  'color-orange-950': 1,
  'color-orange-static': 1,
  'color-orange': 1,
  'color-primary-0-static': 1,
  'color-primary-0': 1,
  'color-primary-100-static': 1,
  'color-primary-100': 1,
  'color-primary-1000-static': 1,
  'color-primary-1000': 1,
  'color-primary-200-static': 1,
  'color-primary-200': 1,
  'color-primary-300-static': 1,
  'color-primary-300': 1,
  'color-primary-400-static': 1,
  'color-primary-400': 1,
  'color-primary-50-static': 1,
  'color-primary-50': 1,
  'color-primary-500-static': 1,
  'color-primary-500': 1,
  'color-primary-600-static': 1,
  'color-primary-600': 1,
  'color-primary-700-static': 1,
  'color-primary-700': 1,
  'color-primary-75-static': 1,
  'color-primary-75': 1,
  'color-primary-800-static': 1,
  'color-primary-800': 1,
  'color-primary-900-static': 1,
  'color-primary-900': 1,
  'color-primary-950-static': 1,
  'color-primary-950': 1,
  'color-primary-alt-0-static': 1,
  'color-primary-alt-0': 1,
  'color-primary-alt-100-static': 1,
  'color-primary-alt-100': 1,
  'color-primary-alt-1000-static': 1,
  'color-primary-alt-1000': 1,
  'color-primary-alt-200-static': 1,
  'color-primary-alt-200': 1,
  'color-primary-alt-300-static': 1,
  'color-primary-alt-300': 1,
  'color-primary-alt-400-static': 1,
  'color-primary-alt-400': 1,
  'color-primary-alt-50-static': 1,
  'color-primary-alt-50': 1,
  'color-primary-alt-500-static': 1,
  'color-primary-alt-500': 1,
  'color-primary-alt-600-static': 1,
  'color-primary-alt-600': 1,
  'color-primary-alt-700-static': 1,
  'color-primary-alt-700': 1,
  'color-primary-alt-75-static': 1,
  'color-primary-alt-75': 1,
  'color-primary-alt-800-static': 1,
  'color-primary-alt-800': 1,
  'color-primary-alt-900-static': 1,
  'color-primary-alt-900': 1,
  'color-primary-alt-950-static': 1,
  'color-primary-alt-950': 1,
  'color-primary-alt-static': 1,
  'color-primary-alt': 1,
  'color-primary-static': 1,
  'color-primary': 1,
  'color-purple-0-static': 1,
  'color-purple-0': 1,
  'color-purple-100-static': 1,
  'color-purple-100': 1,
  'color-purple-1000-static': 1,
  'color-purple-1000': 1,
  'color-purple-200-static': 1,
  'color-purple-200': 1,
  'color-purple-300-static': 1,
  'color-purple-300': 1,
  'color-purple-400-static': 1,
  'color-purple-400': 1,
  'color-purple-50-static': 1,
  'color-purple-50': 1,
  'color-purple-500-static': 1,
  'color-purple-500': 1,
  'color-purple-600-static': 1,
  'color-purple-600': 1,
  'color-purple-700-static': 1,
  'color-purple-700': 1,
  'color-purple-75-static': 1,
  'color-purple-75': 1,
  'color-purple-800-static': 1,
  'color-purple-800': 1,
  'color-purple-900-static': 1,
  'color-purple-900': 1,
  'color-purple-950-static': 1,
  'color-purple-950': 1,
  'color-purple-static': 1,
  'color-purple': 1,
  'color-red-0-static': 1,
  'color-red-0': 1,
  'color-red-100-static': 1,
  'color-red-100': 1,
  'color-red-1000-static': 1,
  'color-red-1000': 1,
  'color-red-200-static': 1,
  'color-red-200': 1,
  'color-red-300-static': 1,
  'color-red-300': 1,
  'color-red-400-static': 1,
  'color-red-400': 1,
  'color-red-50-static': 1,
  'color-red-50': 1,
  'color-red-500-static': 1,
  'color-red-500': 1,
  'color-red-600-static': 1,
  'color-red-600': 1,
  'color-red-700-static': 1,
  'color-red-700': 1,
  'color-red-75-static': 1,
  'color-red-75': 1,
  'color-red-800-static': 1,
  'color-red-800': 1,
  'color-red-900-static': 1,
  'color-red-900': 1,
  'color-red-950-static': 1,
  'color-red-950': 1,
  'color-red-static': 1,
  'color-red': 1,
  'color-success-0-static': 1,
  'color-success-0': 1,
  'color-success-100-static': 1,
  'color-success-100': 1,
  'color-success-1000-static': 1,
  'color-success-1000': 1,
  'color-success-200-static': 1,
  'color-success-200': 1,
  'color-success-300-static': 1,
  'color-success-300': 1,
  'color-success-400-static': 1,
  'color-success-400': 1,
  'color-success-50-static': 1,
  'color-success-50': 1,
  'color-success-500-static': 1,
  'color-success-500': 1,
  'color-success-600-static': 1,
  'color-success-600': 1,
  'color-success-700-static': 1,
  'color-success-700': 1,
  'color-success-75-static': 1,
  'color-success-75': 1,
  'color-success-800-static': 1,
  'color-success-800': 1,
  'color-success-900-static': 1,
  'color-success-900': 1,
  'color-success-950-static': 1,
  'color-success-950': 1,
  'color-success-static': 1,
  'color-success': 1,
  'color-warn-0-static': 1,
  'color-warn-0': 1,
  'color-warn-100-static': 1,
  'color-warn-100': 1,
  'color-warn-1000-static': 1,
  'color-warn-1000': 1,
  'color-warn-200-static': 1,
  'color-warn-200': 1,
  'color-warn-300-static': 1,
  'color-warn-300': 1,
  'color-warn-400-static': 1,
  'color-warn-400': 1,
  'color-warn-50-static': 1,
  'color-warn-50': 1,
  'color-warn-500-static': 1,
  'color-warn-500': 1,
  'color-warn-600-static': 1,
  'color-warn-600': 1,
  'color-warn-700-static': 1,
  'color-warn-700': 1,
  'color-warn-75-static': 1,
  'color-warn-75': 1,
  'color-warn-800-static': 1,
  'color-warn-800': 1,
  'color-warn-900-static': 1,
  'color-warn-900': 1,
  'color-warn-950-static': 1,
  'color-warn-950': 1,
  'color-warn-static': 1,
  'color-warn': 1,
  'color-yellow-0-static': 1,
  'color-yellow-0': 1,
  'color-yellow-100-static': 1,
  'color-yellow-100': 1,
  'color-yellow-1000-static': 1,
  'color-yellow-1000': 1,
  'color-yellow-200-static': 1,
  'color-yellow-200': 1,
  'color-yellow-300-static': 1,
  'color-yellow-300': 1,
  'color-yellow-400-static': 1,
  'color-yellow-400': 1,
  'color-yellow-50-static': 1,
  'color-yellow-50': 1,
  'color-yellow-500-static': 1,
  'color-yellow-500': 1,
  'color-yellow-600-static': 1,
  'color-yellow-600': 1,
  'color-yellow-700-static': 1,
  'color-yellow-700': 1,
  'color-yellow-75-static': 1,
  'color-yellow-75': 1,
  'color-yellow-800-static': 1,
  'color-yellow-800': 1,
  'color-yellow-900-static': 1,
  'color-yellow-900': 1,
  'color-yellow-950-static': 1,
  'color-yellow-950': 1,
  'color-yellow-static': 1,
  'color-yellow': 1,
  'color-text-body': 1,
  'color-text-subtle': 1,
  'color-text-inverse-body': 1,
  'color-text-inverse-subtle': 1,
  'color-link-default': 1,
  'color-link-hover': 1,
  'color-link-active': 1,
  'color-link-inverse-default': 1
};
const themeSizeValuesObject = {
  'size-50': 1,
  'size-100': 1,
  'size-150': 1,
  'size-200': 1,
  'size-250': 1,
  'size-300': 1,
  'size-400': 1,
  'size-500': 1,
  'size-600': 1,
  'size-700': 1,
  'size-800': 1,
  'size-900': 1,
  'size-1000': 1,
  'size-1100': 1,
  'size-1200': 1
};
const ThemeColorValues = Object.keys(themeColorValuesObject);
const ThemeSizeValues = Object.keys(themeSizeValuesObject);

/**
 * Converts strings with the name of a theme color to a CSS variable literal
 * (e.g. 'color-danger-500' to 'var(--color-danger-500)').
 * Strings not matching a theme color are returned unchanged (e.g. '#000000').
 */
function themeColorToCssVariable(color) {
  if (color && ThemeColorValues.includes(color)) {
    return `var(--${color})`;
  }
  return color;
}

/**
 * Converts strings with the name of a theme size to a CSS variable literal
 * (e.g. 'size-500' to 'var(--size-500)').
 * Strings not matching a theme size are returned unchanged (e.g. '1rem').
 */
function themeSizeToCssVariable(size) {
  if (size && ThemeSizeValues.includes(size)) {
    return `var(--${size})`;
  }
  return size;
}

/**
 * Converts strings with the name of a theme border radius to a CSS variable literal
 * (e.g. 'border-radius-default' to 'var(--border-radius-default)').
 * Strings not matching a theme border radius are returned unchanged (e.g. '1rem').
 */
function themeBorderRadiusToCssVariable(borderRadius) {
  if (borderRadius && (borderRadius === 'border-radius-default' || borderRadius === 'border-radius-full')) {
    return `var(--${borderRadius})`;
  }
  return borderRadius;
}

/** Given a base color and a weight, provides the value of that color weight.  */
function useColorWeight(name, weight, ref) {
  const parts = name.split('-');
  const colorName = parts[1];
  const isStatic = parts.includes('static');
  const newParts = isStatic ? ['color', colorName, weight.toString(), 'static'] : ['color', colorName, weight.toString()];
  const newName = newParts.join('-');
  return useThemeVariable(newName, ref);
}

const defaultTheme = 'dsx-theme-default';
const legacyTheme = 'dsx-theme-legacy';
const lightTheme = 'dsx-theme-light';
const darkTheme = 'dsx-theme-dark';

export { ThemeColorValues, darkTheme, defaultTheme, legacyTheme, lightTheme, themeBorderRadiusToCssVariable, themeColorToCssVariable, themeSizeToCssVariable, useColorWeight };
